module.exports = __webpack_public_path__ + "img/recommed-img10.d9be65d6.jpg";